import Vue from 'vue'
import {AUTH_REQUEST} from '../store/actions/auth'
import { mapGetters } from 'vuex'

export default {
	name: 'login',
	props: ['message'],
	data () {
		return {
			showlostpassword: false,
			username: '',
			password: '',
			error: '',
			Message: '',
		}
	},
	methods: {
		login: function () {
			const { username, password } = this
			var that = this
			this.$store.dispatch('AUTH_REQUEST', { username, password }).then((result) => {
				if(result.loginError) {
					that.error = result.loginError
					alert(result.loginError)
				}
				else {
				that.error = ''
				this.$forceUpdate();
				this.$router.push('/websites/list')
				}
			})
		},
		showForgotPassword: function() {
			this.showlostpassword = (this.showlostpassword === false)
			}
		},
	computed: {
		errClass: function () {
			return {
			'error': this.error && this.error !== ''
			}
		},
	},
	created: function () {
		if(this.message) {
			this.$toastr.Add({
				title: "Success", // Toast Title
				msg: this.message,
				position: "toast-top-center",
				type: "success"
		});
		}

	}
}
